// Toggle Form - Secondary Variant
attachEvent('.form-module__form-toggle', 'click', (ev) => {
  const parentEle = ev.target.closest('.form-module--secondary');
  const formEle = parentEle.querySelector('.form-module__form');
  formEle?.classList.add('is-visible');
});
